export type DeskLane = 'review' | 'preparing' | 'scheduled' | 'complete';
export const deskLane = (run: { stage: string; articleId?:string|null }): DeskLane => {
  if (run.stage==='attention' && run.articleId===null) return 'preparing';
  if (['planning','queued','editing','topic', 'structure', 'images'].includes(run.stage)) return 'preparing';
  if (['assembly', 'publication', 'pinterest'].includes(run.stage))
    return 'scheduled';
  if (run.stage === 'complete') return 'complete';
  return 'review';
};
export const selectedDeskLane = (value: string | null): DeskLane =>
  ['review', 'preparing', 'scheduled', 'complete'].includes(value ?? '')
    ? (value as DeskLane)
    : 'review';
export function validIdeaCollection(
  sections: number,
  stacks: number,
  minimum: number,
  maximum: number
): boolean {
  return (
    [sections, stacks, minimum, maximum].every(Number.isInteger) &&
    sections >= 1 &&
    stacks >= 1 &&
    stacks <= 2 &&
    minimum >= 1 &&
    maximum >= minimum &&
    sections * stacks * maximum + 1 <= 55
  );
}
